var LANGUAGE = 'hefe-language'

var initLanguage = localStorage[LANGUAGE]

var plugin = store => {
  store.subscribe((mutation) => {
    switch (mutation.type) {
      case 'setLanguage':
        localStorage[LANGUAGE] = mutation.payload
        break
    }
  })
}

export default plugin
export { initLanguage }
